import { ProfileTabContainer } from '../../components/ProfileComponents';
import { ProjectPlanSection } from '../../components/ProjectPlanSection';
import {
  ActionUpdateOutcomeEnum,
  AdminProjectPlan,
  IntroductionDetailResponseActionUpdates,
} from '@platform/client/schemas';
import { formatDateStr } from '../../../util/DateHelpers';

export const ProjectPlanTabContent = ({
  planData,
  actionUpdates,
}: {
  planData?: AdminProjectPlan | null;
  actionUpdates?: IntroductionDetailResponseActionUpdates;
}) => {
  const deliverables =
    actionUpdates?.filter((update) => update.outcome === ActionUpdateOutcomeEnum.complete) ?? [];

  return (
    <ProfileTabContainer>
      <h2 className='text-xl font-semibold mb-2'>Project Plan</h2>
      {planData ?
        <ProjectPlanSection planData={planData} />
      : <div>No project plan data available.</div>}
      <h2 className='text-xl font-semibold mt-6 mb-2'>Project Deliverables</h2>
      {deliverables.length === 0 ?
        <div>No project deliverables submitted yet.</div>
      : <ul className='space-y-2'>
          {deliverables.map((update, index) => (
            <li key={index} className='shadow-xs border border-gray-200 p-2 rounded-lg'>
              <div className='text-sm text-gray-700'>{update.notes}</div>
              <div className='text-xs text-gray-400 mt-1'>
                {update.userName} &middot; {formatDateStr(new Date(update.updateDate))}
              </div>
            </li>
          ))}
        </ul>
      }
    </ProfileTabContainer>
  );
};
